import NoData from "./no-data";

export default NoData;